import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PERMISSION_ACTIONS, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import {
  Popover,
  ICONS,
  PLATFORM_THEME_COLORS,
  Avatar,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { IEmployee } from 'src/pages/jobs/jobs.interfaces';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { EMPLOYEE_PAGES } from 'src/pages/employee/employee.constants';
import { usePermissionCheck } from 'src/hooks/permission-check.hook';

const EmployeeRowPopover = ({
  employee,
  setJobToEmployeeHandler,
  removeEmployeeFromJobPlace,
}: {
  employee?: IEmployee;
  setJobToEmployeeHandler?: () => void;
  removeEmployeeFromJobPlace?: () => void;
}) => {
  const { t } = useTranslation(['jobs', 'employee']);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { checkRule } = usePermissionCheck(PLATFORM_PERMISSIONS.memberManagement);

  const canCreate = checkRule(PERMISSION_ACTIONS.create);

  return (
    <div>
      <Popover
        placement="rightTop"
        trigger="click"
        visible={visible}
        onVisibleChange={setVisible}
        elements={[
          ...(employee
            ? [
                {
                  label: t('jobs:labels.viewEmployeeProfile'),
                  icon: ICONS.foodMenu,
                  key: ICONS.foodMenu,
                  handler: () =>
                    navigate(
                      `${ROUTES.employee}?type=${EMPLOYEE_PAGES.employeeProfile}&id=${employee._id}`
                    ),
                },
                {
                  label: t('jobs:buttons.removeFromJobPlace'),
                  icon: ICONS.xCircleRegular,
                  key: ICONS.xCircleRegular,
                  color: PLATFORM_THEME_COLORS.tone.red,
                  handler: () => {
                    if (removeEmployeeFromJobPlace) {
                      removeEmployeeFromJobPlace();
                      setVisible(false);
                    }
                  },
                },
              ]
            : [
                {
                  label: t('jobs:labels.setJobToEmployee'),
                  icon: ICONS.userPlus,
                  key: ICONS.userPlus,
                  ...(!canCreate && { color: PLATFORM_THEME_COLORS.grayVariations.murky }),
                  handler: () => {
                    if (setJobToEmployeeHandler && canCreate) {
                      setJobToEmployeeHandler();
                      setVisible(false);
                    }
                  },
                },
              ]),
        ]}
      >
        <Avatar size={24} avatar={employee ? employee.profile.avatarUrl : ''} />
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {employee ? employee.profile.displayName : t('jobs:labels.emptyJobPlace')}
        </Typography>
      </Popover>
    </div>
  );
};

export default EmployeeRowPopover;
